import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('negociacao', 'acordo');

const acordoActions = {
  pesquisar: { method: 'GET', url: `${basePath}` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  gravar: { method: 'POST', url: `${basePath}` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  finalizar: { method: 'PUT', url: `${basePath}/{id}/finalizar` },
  ajustar: { method: 'PUT', url: `${basePath}/{id}/ajustar` },
  ajustarMultiplos: { method: 'PUT', url: `${basePath}/ajustar` },
  encerrarPorId: { method: 'PUT', url: `${basePath}/{idAcordo}/encerrar` },
  encerrar: { method: 'PUT', url: `${basePath}/encerrar` },
  cancelar: { method: 'PUT', url: `${basePath}/{id}/cancelar` },
  cancelarMultiplos: { method: 'PUT', url: `${basePath}/cancelar` },
  copiar: { method: 'GET', url: `${basePath}/{id}/copiar` },
  logAcordo: { method: 'GET', url: `${basePath}/{codigo}/justificativas` },
  listarTiposAcordo: { method: 'GET', url: `${basePath}/tipos-acordo` },
  historico: { logsmehtod: 'GET', url: `${basePath}/{id}/logs` },
  anos: { method: 'GET', url: `${basePath}/anos` },
  meses: { method: 'GET', url: `${basePath}/meses` },
  listarMetas: { method: 'GET', url: `${basePath}/{id}/metas` },
  validarProdutosEleitos: { method: 'GET', url: `${basePath}/{id}/metas/validar/produtos-eleitos` },
  encerramentoSaldoRetornavel: { method: 'GET', url: `${basePath}/{idAcordo}/encerramento/saldo-retornavel` },
  permiteEncerrarAcordo: { method: 'GET', url: `${basePath}/{idAcordo}/permite-encerrar` },
  tiposLinhaAcordo: { method: 'GET', url: `${basePath}/conta-corrente/tipo-investimento?colunaOrdenacao=desc_investimento` },
  linhasInvestimentoAcordo: { method: 'GET', url: `${basePath}/conta-corrente/tipo-investimento/{idTipoInvestimento}?colunaOrdenacao=desc_investimento` },
  saldoDisponivel: { method: 'GET', url: `${basePath}/conta-corrente/{idLinhaInvestimento}/saldo?anoMesInicio={anoMesInicio}&anoMesFim={anoMesFim}` },
  ratear: { method: 'POST', url: `${basePath}/rateio` },
};

export default resource => resource(`${basePath}`, {}, acordoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/acordo.js